import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import UserProfile from '../views/UserProfile.vue'
import RestoreAccountView from '../views/RestoreAccountView.vue'
import PrivacyPolicyView from '../views/PrivacyPolicyView.vue'
import UserAgreementView from '../views/UserAgreementView.vue'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import ResourcesHomeView from '../views/resources/ResourcesHomeView.vue'
import CompanyDetailView from '../views/resources/CompanyDetailView.vue'
import PositionsView from '../views/resources/PositionsView.vue'
import PositionDetailView from '../views/resources/PositionDetailView.vue'
import SimpleResourceManagement from '../views/resource/SimpleResourceManagement.vue'
import ResourceManagement from '../views/resource/ResourceManagement.vue'
import XiaoguoSquare from '../views/XiaoguoSquare.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
    meta: { requiresAuth: false }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/ForgotPasswordView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/views/ResetPasswordView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/user-profile',
    name: 'user-profile',
    component: UserProfile,
    meta: {
      title: '用户资料'
    }
  },
  {
    path: '/vip-redeem',
    name: 'vip-redeem',
    redirect: '/'
  },
  {
    path: '/resume',
    name: 'resume',
    // 使用懒加载方式导入组件，提高首屏加载速度
    component: () => import(/* webpackChunkName: "resume" */ '../views/ResumeView.vue'),
    meta: {
      title: '简历优化',
      requiresAuth: true
    }
  },
  {
    path: '/xiaoguo-square',
    name: 'xiaoguo-square',
    component: XiaoguoSquare,
    meta: {
      title: '小果广场',
      requiresAuth: true
    }
  },
  {
    path: '/resources',
    name: 'resources',
    component: ResourcesHomeView,
    meta: {
      title: '资源管理',
      requiresAuth: true
    }
  },
  {
    path: '/resources/companies/:id',
    name: 'company-detail',
    component: CompanyDetailView,
    props: true,
    meta: {
      title: '公司详情',
      requiresAuth: true
    }
  },
  {
    path: '/resources/positions',
    name: 'positions',
    component: PositionsView,
    meta: {
      title: '职位管理',
      requiresAuth: true
    }
  },
  {
    path: '/resources/positions/:id',
    name: 'position-detail',
    component: PositionDetailView,
    props: true,
    meta: {
      title: '职位详情',
      requiresAuth: true
    }
  },
  {
    path: '/resources/collections',
    name: 'collections',
    component: () => import(/* webpackChunkName: "resources" */ '../views/resources/CollectionsView.vue'),
    meta: {
      title: '资源收藏',
      requiresAuth: true
    }
  },
  {
    path: '/resources/interviews',
    name: 'interviews',
    component: () => import(/* webpackChunkName: "resources" */ '../views/resources/InterviewsView.vue'),
    meta: {
      title: '面试进度',
      requiresAuth: true
    }
  },
  {
    path: '/resources/calendar',
    name: 'calendar',
    component: () => import(/* webpackChunkName: "resources" */ '../views/resources/CalendarView.vue'),
    meta: {
      title: '求职日历',
      requiresAuth: true
    }
  },
  {
    path: '/resources/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "resources" */ '../views/resources/DashboardView.vue'),
    meta: {
      title: '数据统计',
      requiresAuth: true
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: {
      title: '关于'
    }
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('@/views/NotificationsView.vue'),
    meta: {
      requiresAuth: true,
      title: '系统通知'
    }
  },
  {
    path: '/notifications/:id',
    name: 'notification-detail',
    component: () => import('@/views/NotificationDetailView.vue')
  },
  {
    path: '/restore-account',
    name: 'restore-account',
    component: RestoreAccountView,
    meta: {
      title: '账号恢复',
      requiresAuth: false
    }
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicyView,
    meta: {
      title: '隐私政策',
      requiresAuth: false
    }
  },
  {
    path: '/user-agreement',
    name: 'user-agreement',
    component: UserAgreementView,
    meta: {
      title: '用户协议',
      requiresAuth: false
    }
  },
  {
    path: '/resources/simple',
    name: 'simple-resource-management',
    component: SimpleResourceManagement,
    meta: {
      title: '极简资源管理',
      requiresAuth: true
    }
  },
  {
    path: '/resources/management',
    name: 'resource-management',
    component: ResourcesHomeView,
    meta: {
      title: '资源管理',
      requiresAuth: true
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 全局前置守卫，设置页面标题和认证检查
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = `${to.meta.title || '首页'} - AI简历助手`
  
  // 检查是否需要认证
  if (to.meta.requiresAuth && !localStorage.getItem('token')) {
    next({ name: 'login', query: { redirect: to.fullPath } });
    return;
  }
  
  next();
})

export default router
